/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_BillingInputs */

const cs_nav_billing = /** @type {(inputs: Nav_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredity`)
};

const en_nav_billing = /** @type {(inputs: Nav_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Nav_BillingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_billing = /** @type {((inputs?: Nav_BillingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_BillingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_billing(inputs)
	return cs_nav_billing(inputs)
});